package com.patronat.top.ui.molecules.filters

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.ui.theme.*

@Composable
fun AppFilterDropdown(
    label: String,
    options: List<FilterOption>,
    selectedOptions: List<FilterOption>, // Тепер список! (Empty = Всі)
    onOptionSelected: (List<FilterOption>) -> Unit, // Повертає новий список
    modifier: Modifier = Modifier,
    allOptionLabel: String = "Всі"
) {
    var expanded by remember { mutableStateOf(false) }

    // Логіка тексту на кнопці
    val displayText = remember(selectedOptions) {
        when {
            selectedOptions.isEmpty() -> allOptionLabel
            selectedOptions.size == 1 -> selectedOptions.first().label
            selectedOptions.size == options.size -> allOptionLabel
            else -> "${selectedOptions.size}" // Показуємо кількість, якщо > 1
        }
    }

    Box(modifier = modifier) {
        // --- КНОПКА ---
        Row(
            modifier = Modifier
                .height(48.dp)
                .clip(RoundedCornerShape(16.dp))
                .background(Primary100)
                .clickable { expanded = !expanded }
                .padding(horizontal = 16.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = AppIcons.Filter,
                contentDescription = null,
                tint = Primary600,
                modifier = Modifier.size(20.dp)
            )

            Spacer(modifier = Modifier.width(8.dp))

            Text(
                text = label,
                style = LabelLarge.copy(color = MineShaft900)
            )

            Spacer(modifier = Modifier.width(4.dp))

            // Жирний текст значення
            Text(
                text = displayText,
                style = LabelLarge.copy(color = MineShaft900)
            )

            Spacer(modifier = Modifier.width(8.dp))

            Icon(
                painter = AppIcons.ArrowDown,
                contentDescription = null,
                tint = MineShaft900,
                modifier = Modifier
                    .size(16.dp)
                    .rotate(if (expanded) 180f else 0f)
            )
        }

        // --- МЕНЮ ---
        MaterialTheme(
            shapes = MaterialTheme.shapes.copy(extraSmall = RoundedCornerShape(12.dp))
        ) {
            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false }, // Закриваємо тільки тут!
                modifier = Modifier
                    .background(White)
                    .width(IntrinsicSize.Max) // Або 240.dp
                    .heightIn(max = 300.dp)   // Обмеження висоти для скролу
                    .padding(vertical = 4.dp),
                containerColor = White,
                tonalElevation = 0.dp,
                shadowElevation = 8.dp
            ) {
                // 1. Опція "Всі"
                val isAllSelected = selectedOptions.isEmpty()

                DropdownItemRow(
                    text = allOptionLabel,
                    isSelected = isAllSelected,
                    onClick = {
                        // Логіка: Клік по "Всі" очищає вибір (що означає "вибрати все")
                        onOptionSelected(emptyList())
                        // expanded = false // НЕ закриваємо меню
                    }
                )

                HorizontalDivider(modifier = Modifier.padding(vertical = 4.dp))

                // 2. Список опцій
                options.forEach { option ->
                    // Перевіряємо по ID, чи є елемент у списку вибраних
                    val isSelected = selectedOptions.any { it.id == option.id }

                    DropdownItemRow(
                        text = option.label,
                        isSelected = isSelected,
                        onClick = {
                            val newList = if (isSelected) {
                                // Якщо вже вибрано -> видаляємо
                                selectedOptions.filter { it.id != option.id }
                            } else {
                                // Якщо не вибрано -> додаємо
                                selectedOptions + option
                            }

                            // Смарт-логіка:
                            // Якщо вибрали вручну ВСІ пункти -> перетворюємо це на "Всі" (emptyList)
                            if (newList.size == options.size) {
                                onOptionSelected(emptyList())
                            } else {
                                onOptionSelected(newList)
                            }
                            // expanded = false // НЕ закриваємо меню
                        }
                    )
                }
            }
        }
    }
}

// --- ROW ITEM ---
@Composable
private fun DropdownItemRow(
    text: String,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    DropdownMenuItem(
        text = {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = text,
                    style = BodyMedium.copy(
                        color = if (isSelected) MineShaft950 else MineShaft500,
                        fontSize = 12.sp,
                        lineHeight = 18.sp)
                )

                // Checkbox Icon
                Icon(
                    painter = if (isSelected) AppIcons.CheckboxOn else AppIcons.CheckboxOff,
                    contentDescription = null,
                    tint = Color.Unspecified,
                    modifier = Modifier.size(16.dp)
                )
            }
        },
        onClick = onClick,
        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 0.dp), // Compact padding
        modifier = Modifier.height(34.dp).width(165.dp) // Фіксована висота рядка для зручності
    )
}